<template>
  <div>
    <Header></Header>
    <div class="col-12 d-inline-flex">
      <div class="col-10 no-overflow ms-3 me-3 pt-3" style="position: relative;">
        <h2>CDN Regions</h2>
        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex justify-content-between align-items-center">
            <a role="button" class="procricket-btn mb-3" @click="redirectToCreate">Create New Entry</a>
          </div>
          <input type="text" class="form-control mb-3" placeholder="Search in CDN regions..." v-model="searchText" style="width: 20%; position: relative; ">
        </div>
        <div class="table-responsive">
          <table class="table table-striped table-bordered">
            <thead>
            <tr>
              <th class="col-1" @click="toggleSort('cdnRegionKey')">CDN region key</th>
              <th class="col-1" @click="toggleSort('cdnRegionValue')">CDN region value</th>
              <th class="col-1" @click="toggleSort('active')">Active</th>
              <th class="col-1" @click="toggleSort('application')">Application</th>
              <th class="col-1" @click="toggleSort('updated')">Updated</th>

              <th class="col-1">Edit</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="config in sortData" :key="config.cdnRegionKey">
              <td class="col-1 text-truncate" v-html="truncateText(config.cdnRegionKey, 30)" @click="selectText" :data-text="config.cdnRegionKey"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.cdnRegionValue, 30)" @click="selectText" :data-text="config.cdnRegionValue"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.active, 30)" @click="selectText" :data-text="config.active"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.application, 30)" @click="selectText" :data-text="config.application"></td>
              <td class="col-1 text-truncate" v-html="functions.formatUnixTimestamp(config.updated)" @click="selectText" :data-text="config.updated"></td>
              <td class="col-1 centered">
                <router-link :to="{ name: 'CDNRegionEdit', params: { id: config.cdnRegionKey, ...config } }" class="procricket-btn">
                  Edit
                </router-link>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <a role="button" class="procricket-btn mb-3" @click="openSearch">Deactivate CDN region</a>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <div class="modal d-block" v-if="showModal">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title fw-bold">Replace CDN region</h4>
            <button role="button" class="close close-modal" data-dismiss="modal" aria-label="Close" @click="closeSearch">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form class="modal-form">
              <label>Deactivate region key</label>
              <input type="text" v-model="cdnRegionDeactivate.deactivateCdnRegionKey">
              <label >Replacing region key</label>
              <input type="text" v-model="cdnRegionDeactivate.replaceCdnRegionKey">
            </form>
          </div>
          <div class="modal-footer">
            <a class="btn cancel-btn" role="button" data-dismiss="modal" @click="closeSearch">Cancel</a>
            <a class="btn signout-popup text-white" role="button" @click="doReplaceRegion">Replace</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AdminService from "@/services/admin-service";
import Header from "@/components/Header.vue";
import {CDNRegionDeactivate} from "@/model/models";
import functions from "@/functions"

export default {
  name: "CDNRegions",
  components: {
    Header,
  },
  data() {
    return {
      searchText: '',
      RegionList: [],
      sortColumn: '',  // Add this property
      sortDirection: 'asc',
      showModal: false,
      cdnRegionDeactivate: new CDNRegionDeactivate(null, null)
    };
  },
  computed: {
    functions() {
      return functions
    },
    filteredCouponsList() {
      const search = this.searchText.toLowerCase().trim();
      let filteredList = this.RegionList.filter((config) => {
        return (
            (config.cdnRegionKey && config.cdnRegionKey.toString().includes(search)) ||
            (config.cdnRegionValue && config.cdnRegionValue.toLowerCase().includes(search)) ||
            (config.active && config.active.toString().includes(search)) ||
            (config.application && config.application.toString().includes(search)) ||
            (config.updated && config.updated.toString().includes(search))
        );
      });

      if (this.sortColumn) {
        const direction = this.sortDirection === 'asc' ? 1 : -1;
        filteredList = filteredList.sort((a, b) => {
          const valueA = a[this.sortColumn];
          const valueB = b[this.sortColumn];

          if (valueA < valueB) return -1 * direction;
          if (valueA > valueB) return 1 * direction;
          return 0;
        });
      }
      return filteredList;
    },
    sortData() {
      return this.filteredCouponsList;
    },
  },
  created() {
    this.doLoadPlans();
    document.addEventListener('click', (event) => this.handleClickAnywhere(event));

    this.sortColumn = 'cdnRegionKey';
  },
  methods: {
    doLoadPlans() {
      AdminService.getCDNRegionList().then((data) => {
        this.RegionList = data;
      }).catch((error) => {
        console.error("Error loading regions:", error);
      });
    },
    wrapText(text, limit) {
      if (text.length > limit) {
        const firstLine = text.substring(0, limit);
        const secondLine = text.substring(limit);
        return `${firstLine}<br>${secondLine}`;
      } else {
        return text;
      }
    },
    truncateText(text, limit) {
      return text.length > limit ? text.substring(0, limit) + '...' : text;
    },
    redirectToCreate() {
      this.$router.push({ name: 'CDNRegionCreate' }); // Navigate to the StripeEdit route without params
    },
    async selectText(event) {
      const originalText = event.target.getAttribute('data-text');
      try {
        await navigator.clipboard.writeText(originalText);
        this.highlightElement(event.target);
      } catch (err) {
        console.error('Failed to copy text: ', err);
      }
    },
    highlightElement(element) {
      this.removeHighlight();
      element.style.backgroundColor = 'yellow'; // Add highlight
      this.highlightedElement = element;
      setTimeout(this.removeHighlight, 10000); // Remove highlight after 10 seconds
    },
    removeHighlight() {
      if (this.highlightedElement) {
        this.highlightedElement.style.backgroundColor = ''; // Remove highlight
        this.highlightedElement = null;
      }
    },
    handleClickAnywhere() {
      this.removeHighlight()
    },
    toggleSort(column) {
      if (this.sortColumn === column) {
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortColumn = column;
        this.sortDirection = 'asc';
      }
    },
    openSearch() {
      this.cdnRegionDeactivate = new CDNRegionDeactivate(null, null)
      this.showModal = true
    },
    closeSearch() {
      this.cdnRegionDeactivate = new CDNRegionDeactivate(null, null)
      this.showModal = false
    },
    doReplaceRegion() {
      if (this.cdnRegionDeactivate.deactivateCdnRegionKey !== null && this.cdnRegionDeactivate.replaceCdnRegionKey !== null
          && this.RegionList.some(region => region.cdnRegionKey === this.cdnRegionDeactivate.deactivateCdnRegionKey)
          && this.RegionList.some(region => region.cdnRegionKey === this.cdnRegionDeactivate.replaceCdnRegionKey)) {
        AdminService.deactivateCDNRegion(this.cdnRegionDeactivate).then(() => {
          alert('Deactivation is complete');
          // Redirect to the page
          this.closeSearch()
          this.$router.push({ name: 'Regions' });
        }).catch((error) => {
          this.error = error.message
        });
      } else {
        alert('Keys must be existing cdn regions keys.');
      }
    },
  },
};
</script>
<style src="../../assets/style.css">
</style>
